import React, { FC } from 'react';

interface HtmlPageProps {
  src: string;
}

const HtmlPage: FC<HtmlPageProps> = ({ src }) => {
  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe src={src} style={{ width: '100%', height: '100%', border: 'none' }} title="HTML Content" />
    </div>
  );
};

export default HtmlPage;
